import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer } from "@/components/ui/page-container";
import { TrashView } from "@/features/trash/components/trash-view";

function TrashRoutePage() {
  // Sin gate de auth: la papelera es local-first y opera sobre el SQLite de la
  // cuenta activa; sin org simplemente muestra el estado vacío.
  return (
    <PageContainer maxWidth="3xl">
      <TrashView />
    </PageContainer>
  );
}

export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: TrashRoutePage,
});
